import React from 'react';
import Button from 'react-bootstrap/Button';

import MassUpdate from '../settings/automation/MassUpdate';

class MassUpdatePopup extends React.Component {

  onUpdateChanged = updates => this.updates = updates;

  render() {
    return (
      <div className="popup-box">
        <div className="box">
          <div className="col-md-12 text-right">
            <button type="button" className="close" aria-label="Close"
              onClick={this.props.showMassUpdate}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="row">
            <div className="col-md-6 mt-5 filterul filterul2">
              <p className="redcol"><strong>Note:</strong> Once Mass Update Done, It Can Not Undo / Reverse.</p>
              <MassUpdate model={this.props.models}
                onUpdateChanged={this.onUpdateChanged} value={[{}]} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mt-2 mass-ml">
              <Button onClick={() => this.props.onMassUpdate(this.updates)}>Submit</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default MassUpdatePopup;